var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardCancelledDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.38867C9.89032 1.38867 7.82803 2.04033 6.0739 3.26123C4.31978 4.48214 2.9526 6.21745 2.14527 8.24774C1.33793 10.278 1.1267 12.5121 1.53827 14.6675C1.94985 16.8228 2.96575 18.8026 4.45751 20.3565C5.94927 21.9104 7.84989 22.9687 9.91902 23.3974C11.9882 23.8261 14.1329 23.6061 16.0819 22.7651C18.031 21.9241 19.6969 20.5 20.869 18.6728C22.0411 16.8456 22.6667 14.6974 22.6667 12.4998C22.6667 9.55293 21.5428 6.72678 19.5425 4.64304C17.5421 2.5593 14.829 1.38867 12 1.38867ZM2.66665 12.4998C2.66729 10.1636 3.47952 7.90656 4.95332 6.14562L18.1 19.8401C16.7479 21.0563 15.0892 21.8427 13.3207 22.1061C11.5523 22.3694 9.74848 22.0985 8.12344 21.3256C6.49841 20.5527 5.12044 19.3103 4.15318 17.7458C3.18591 16.1814 2.66998 14.3606 2.66665 12.4998ZM19.0466 18.8539L5.89998 5.1595C7.68889 3.60251 9.97239 2.79923 12.3012 2.90768C14.6301 3.01614 16.8357 4.02848 18.484 5.74555C20.1324 7.46262 21.1043 9.7601 21.2084 12.186C21.3125 14.6119 20.5414 16.9905 19.0466 18.8539Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCancelledDetails);
export default __webpack_public_path__ + "static/media/dashboard_cancelled_details.ac67bd533ce1723916cc3d3dca3f28a0.svg";
export { ForwardRef as ReactComponent };